import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import FieldLabel from "../../../components/label";
import { Autocomplete, Box, TextField } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { postWebService } from "../../../helpers/server";
import { rebuildOccupationList } from "../../../helpers/utils";

const CheckOccupation = ({
  classes: { formGroup },
  selectedOccupationOption,
  setSelectedOccupationOption,
}) => {
  const { state, dispatch } = useContext(ApplicationContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    async function fetchOccupationList() {
      try {
        const response = await postWebService("occupations.php", {});

        cbSuccess(response.data);
      } catch (error) {
        // console.log(error);
      }
    }
    fetchOccupationList();
  }, []);

  const cbSuccess = ({ data }) => {
    dispatchEvent(ReducerUtils.occupation.list, rebuildOccupationList(data));
    setTimeout(() => setIsLoaded(true), 100);
  };

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  return (
    isLoaded &&
    state?.occupations?.length > 0 && (
      <Box>
        <Box className={formGroup}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={state?.occupations}
            filterOptions={(options, { inputValue }) => {
              const seen = new Set();
              return options.filter((option) => {
                const label = option.label.toLowerCase();
                const startsWith = label.startsWith(inputValue.toLowerCase());
                const isUnique = !seen.has(label);
                if (startsWith && isUnique) {
                  seen.add(label);
                  return true;
                }
                return false;
              });
            }}
            value={selectedOccupationOption}
            onChange={(event, newValue) => {
              setSelectedOccupationOption(newValue);
            }}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Start Typing" />
            )}
            sx={{
              "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                backgroundColor: "#F6F6F6",
                fontWeight: "400 !important",
                display: "flex",
                justifyContent: "flex-start",
                textAlign: "left",
                margin: "2px 0px",
              },
            }}
          />
        </Box>

        {selectedOccupationOption && (
          <Box className={formGroup}>
            {selectedOccupationOption?.risk_categorization === "High" ? (
              <Box mt={2}>
                <FieldLabel
                  label={`Apologies, your selected occupation does not match with our eligibility criteria.`}
                  color="error"
                />
              </Box>
            ) : (
              <Box mt={2}>
                <FieldLabel
                  label={`Congratulations! Your selected occupation matched with our eligibility criteria.`}
                  color="green"
                />
              </Box>
            )}
          </Box>
        )}
      </Box>
    )
  );
};

export default withStyles(useStyles, { withTheme: true })(CheckOccupation);
